import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import { CustomInput } from "../../../../Forms";

//Assets
import ArrowGrey from "../../../../../images/arrow-grey.png";

//Interfaces
import { AwbOrSelfDropoffInterface } from "../definitions";

const AwbOrSelfDropoff: FC<AwbOrSelfDropoffInterface> = ({ 
  selectedLogistic,
  awbNumber,
  selectedScheduled,
  selectedDate,
  onChangeAwbNumber,
  setDropoffScheduled,
  parseTextHandler
}) => {
  if (selectedLogistic.value !== "self-drop-off") return (
    <CustomInput
      value={awbNumber}
      placeholder={"AWB Number / Shipping Tracking Number"}
      className={"input-awb-number"}
      onChange={onChangeAwbNumber}
    />
  )

  return (
    <div className="self-dropoff-button" onClick={() => setDropoffScheduled(true)}>
      {
        selectedScheduled?.start_time ? (
          <p className="placeholder selected">{parseTextHandler(selectedDate?.day)}{", "}{parseTextHandler(selectedDate?.month)}{" "}<span className="date">{selectedDate?.date}<span className="date-suffix">{selectedDate?.suffix}</span></span>{" "}{selectedScheduled.start_time} - {selectedScheduled.end_time} (WIB)</p>
        ) : (
          <p className="placeholder">Drop-off Schedule</p>
        )
      }
      <KickImage src={ArrowGrey} alt="..." className="next-arrow" />
    </div>

  )

}
export default AwbOrSelfDropoff;